<template>
  <div class="active-room">
    <div class="box">
      <div class="title">{{datas.Title}}</div>
      <div class="content">
        <div>
          <span>活动时间：</span>
          {{datas.time | times}}
        </div>
        <div>
          <span>活动地点：</span>
          {{datas.place}}
        </div>
        <div>
          <span>活动类型：</span>
           {{datas.type}}
        </div>
        <div>
          <span>活动内容：</span>
         {{datas.theme}}
        </div>
        
        <button v-if="datas.state" class="true" @click="datas.state=false">接收消息</button>
        <button v-else class="false">已接收</button>
      </div>
      <div class="submit">
        <!-- <button v-if="datas.jurisdiction=='管理员'">创建房间号</button> -->
        <button v-if="buttons">已签到</button>
        <button v-if="!buttons" @click="goMotai" class="yellow">加入房间号</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      buttons:true
    };
  },
  name: "activeRoom",
  props: {
    datas: Object
  },
  methods: {
    goMotai() {
      this.$parent.motai.motais = true;
      this.$parent.motai.title = "请输入房间号";
      this.$parent.motai.button = "确认";
      this.$parent.motai.activeId = this.datas.ID
      this.$parent.motai.isput = true;
      this.$parent.motai.text = "";

    },
    getMsg(){
      this.axios.get(
        `/api/Index/GetCheck?userid=${sessionStorage.getItem('id')}&actiid=${this.datas.ID}`
      ).then(e=>{
        console.log(e.data);
        switch (e.data.code) {
          case 0:
            this.buttons=true
            break;
        
          default:
            this.buttons = false
            break;
        }
      })
    },
    receive(){
      this.axios.post(
        '/api/Index/UserRece',
        {
          id:this.datas.ID,
          userid:sessionStorage.getItem('id')
        }
      ).then(e=>{
        console.log(e.data);
        
      })
    }
  },
  mounted(){
    this.getMsg()
    this.receive()
  }
};
</script>
<style lang='scss' scoped>
.active-room {
  .box {
    .submit {
      .yellow{
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);

      }
      button {
        border-radius: 0.16rem;
        width: 80%;
        padding: 0.2rem 0;
        border: none;
        font-size: 0.3rem;
        color: #fff;
        margin-top: 0.3rem;
      }
      padding: 0 0.2rem;
      text-align: center;
      margin-top: 0.3rem;
    }
    .content {
      .false {
        color: #ffffff;
        font-size: 0.3rem;
        padding: 0.2rem 0.2rem;
        margin-left: 0.4rem;
        border-radius: 0.08rem;
        border: none;
        background-color: #cccccc;
      }
      .true {
        margin-left: 0.4rem;
        padding: 0.2rem 0.2rem;
        border: none;
        color: #ffffff;
        font-size: 0.3rem;
        background-color: #ea5e63;
        border-radius: 0.08rem;
      }
      div {
        span {
          display: inline-block;
          width: 30%;
          text-align: center;
          color: red;
        }
        padding: 0.2rem;
        word-break: break-all;
      }
    }
    .title {
      font-weight: bold;
      //   text-align: center;
      padding: 0.2rem .4rem;
      font-size: 0.36rem;
      
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    min-height: 65vh;
  }
}
</style>